document.addEventListener("alpine:init", () => {
  Alpine.store("cart", {
    // Store actions
    data: {},
    ...window.__ShopifyCart,

    updateStore(json) {
      this.data = json
      this.original_total_price = json.original_total_price
      this.total_price = json.total_price
      this.total_discount = json.total_discount
      this.item_count = json.item_count
      this.items = json.items
      this.currency_symbol = json.currency_symbol
      this.items_subtotal_price = json.items_subtotal_price
    },

    // Cart actions
    addCart(
      items = [
        // {
        //   id: 36110175633573,
        //   quantity: 1,
        // },
      ],
    ) {
      return fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => {
          this.getCart()
          return response.json()
        })
        .catch((error) => {
          return error
        })
    },
    getCart() {
      fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json()
        })
        .then((json) => {
          this.updateStore(json)
        })
        .catch((error) => {
          return error
        })
    },
    updateCart(
      updates = {
        // 794864053: 2,
        // 794864233: 3,
      },
    ) {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          return response.json()
        })
        .then((json) => {
          this.updateStore(json)
          return json
        })
        .catch((error) => {
          return error
        })
    },

    // Quantity
    increaseQuantity(index) {
      this.items[index].quantity += 1
      this.updateQuantity()
    },
    decreaseQuantity(index) {
      if (this.items[index].quantity > 0) {
        this.items[index].quantity -= 1
        this.updateQuantity()
      }
    },
    clearQuantity(index) {
      this.items[index].quantity = 0
      this.updateQuantity()
    },
    updateQuantity() {
      let updates = {}
      this.items.forEach((item) => {
        updates[item.variant_id] = item.quantity
      })

      this.updateCart(updates)
    },

    // Price utilities
    priceDisplay(price) {
      return (parseInt(price) / 100).toFixed(2)
    },

    getPrice(item) {
      if (item.original_price === item.discounted_price) {
        return `${this.priceDisplay(item.discounted_price)}`
      } else {
        return `<span class="line-through">${this.priceDisplay(
          item.original_price,
        )}</span> ${item.discounted_price}`
      }
    },

    getSubtotalPrice(item) {
      if (item.original_line_price === item.line_price) {
        return `${this.priceDisplay(item.line_price)}`
      } else {
        return `<span class="line-through">${this.priceDisplay(
          item.original_line_price,
        )}</span> ${item.line_price}`
      }
    },

    totalAll() {
      if (this.original_total_price === this.total_price) {
        return `${this.priceDisplay(this.total_price)}`
      } else {
        return `<span class="line-through">${this.priceDisplay(
          this.original_total_price,
        )}</span> ${this.total_price}`
      }
    },
  })
})
